import { ApolloClient, gql } from 'apollo-boost';

const portfolioQuery = gql`
  query ($id: ID) {
    allPortfolios(filters: {id: $id}) {
      edges {
        node {
          portfolioId
          name
          accountId
        }
      }
    }
  }
`;

export const getPortfolio = (
  client: ApolloClient<object>,
  id: number
) => {
  const result = client.query({
    query: portfolioQuery,
    variables: { id },
    fetchPolicy: 'network-only',
  });
  return result.then((res) => res.data.allPortfolios.edges[0].node);
};